import { userTypesMessages } from './userTypes';
import { userTitlesMessagesRaw } from './userTitles';
import { userGenderMessages } from './userGender';

export const USER = 'USER';

export const messagesMap = {
  [USER]: { id: 'General.Details', defaultMessage: '** Details' },

  // Titles
 ...userTitlesMessagesRaw,

  // Types
  ...userTypesMessages,

  // Gender
  ...userGenderMessages,

  // Default values
  unknown: { id: 'const.unknown', defaultMessage: '** Unknown' },
  spaceSymbol: { id: 'const.spaceSymbol', defaultMessage: '** Space' },
};
